export const PreQualifierLoadingProductErrorViewStyles = {
  container: 'flex flex-row justify-center text-center',
}
